{
  "familyId": "GET-BREUK-ONG-PLUS",
  "questions": [
    {
      "id": "GET-BREUK-ONG-PLUS-001",
      "familyId": "GET-BREUK-ONG-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_optellen_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{1}{3}$ + $\\frac{1}{6}$ =",
      "context": null,
      "options": ["$\\frac{3}{6}$", "$\\frac{2}{9}$", "$\\frac{1}{9}$", "$\\frac{2}{6}$"],
      "correctAnswer": 0,
      "conceptId": "adding_fractions_unlike_denominators",
      "variantIndex": 1,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 1, "denominator": 3, "label": "1/3"},
              {"numerator": 1, "denominator": 6, "label": "1/6"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 6,
            "label": "1/3 = 2/6, dan 2/6 + 1/6 = 3/6",
            "visualType": "bar"
          }
        }
      ],
      "group": 7,
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{3}{6}$. De noemers zijn ongelijk (3 en 6). Maak ze gelijk: $\\frac{1}{3}$ = $\\frac{2}{6}$. Dan: $\\frac{2}{6}$ + $\\frac{1}{6}$ = $\\frac{3}{6}$ (= $\\frac{1}{2}$).",
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{3}$ = $\\frac{2}{6}$, dan $\\frac{2}{6}$ + $\\frac{1}{6}$ = $\\frac{3}{6}$.",
          "1": "$\\frac{2}{9}$ is fout. Je hebt de tellers opgeteld (1+1=2) én de noemers opgeteld (3+6=9). De noemers mag je niet optellen. Maak ze gelijk: $\\frac{1}{3}$ = $\\frac{2}{6}$, dan $\\frac{2}{6}$ + $\\frac{1}{6}$ = $\\frac{3}{6}$.",
          "2": "$\\frac{1}{9}$ is fout. Je hebt tellers en noemers apart opgeteld of vermenigvuldigd. Maak de noemers gelijk: $\\frac{1}{3}$ = $\\frac{2}{6}$, dan $\\frac{2}{6}$ + $\\frac{1}{6}$ = $\\frac{3}{6}$.",
          "3": "$\\frac{2}{6}$ is fout. Je hebt alleen $\\frac{1}{3}$ omgezet naar $\\frac{2}{6}$ maar de tweede breuk vergeten op te tellen. $\\frac{2}{6}$ + $\\frac{1}{6}$ = $\\frac{3}{6}$."
        }
      }
    },
    {
      "id": "GET-BREUK-ONG-PLUS-002",
      "familyId": "GET-BREUK-ONG-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_optellen_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{1}{2}$ + $\\frac{1}{4}$ =",
      "context": null,
      "options": ["$\\frac{3}{4}$", "$\\frac{2}{6}$", "$\\frac{1}{4}$", "$\\frac{2}{8}$"],
      "correctAnswer": 0,
      "conceptId": "adding_fractions_half_quarter",
      "variantIndex": 2,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 1, "denominator": 2, "label": "1/2"},
              {"numerator": 1, "denominator": 4, "label": "1/4"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "1/2 = 2/4, dan 2/4 + 1/4 = 3/4",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{3}{4}$. De noemers zijn ongelijk (2 en 4). Maak ze gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$. Dan: $\\frac{2}{4}$ + $\\frac{1}{4}$ = $\\frac{3}{4}$.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ + $\\frac{1}{4}$ = $\\frac{3}{4}$.",
          "1": "$\\frac{2}{6}$ is fout. Je hebt de tellers opgeteld (1+1=2) én de noemers opgeteld (2+4=6). De noemers mag je niet optellen. Maak ze gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ + $\\frac{1}{4}$ = $\\frac{3}{4}$.",
          "2": "$\\frac{1}{4}$ is fout. Je hebt alleen de tweede breuk genomen en de eerste vergeten. Maak de noemers gelijk en tel op: $\\frac{2}{4}$ + $\\frac{1}{4}$ = $\\frac{3}{4}$.",
          "3": "$\\frac{2}{8}$ is fout. Je hebt misschien de tellers vermenigvuldigd (1×2=2) en de noemers vermenigvuldigd (2×4=8). Maar bij optellen vermenigvuldig je niet — je maakt de noemers gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ + $\\frac{1}{4}$ = $\\frac{3}{4}$."
        }
      }
    },
    {
      "id": "GET-BREUK-ONG-PLUS-003",
      "familyId": "GET-BREUK-ONG-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_optellen_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{1}{4}$ + $\\frac{1}{3}$ =",
      "context": null,
      "options": ["$\\frac{7}{12}$", "$\\frac{2}{7}$", "$\\frac{2}{12}$", "$\\frac{1}{12}$"],
      "correctAnswer": 0,
      "conceptId": "adding_fractions_quarters_thirds",
      "variantIndex": 3,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 1, "denominator": 4, "label": "1/4"},
              {"numerator": 1, "denominator": 3, "label": "1/3"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 7,
            "denominator": 12,
            "label": "1/4 = 3/12, 1/3 = 4/12, dan 3/12 + 4/12 = 7/12",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{7}{12}$. De noemers zijn ongelijk (4 en 3). Het KGV van 4 en 3 is 12. Maak gelijknamig: $\\frac{1}{4}$ = $\\frac{3}{12}$ en $\\frac{1}{3}$ = $\\frac{4}{12}$. Dan: $\\frac{3}{12}$ + $\\frac{4}{12}$ = $\\frac{7}{12}$.",
        "distractorExplanations": {
          "0": "Goed! KGV van 4 en 3 is 12. $\\frac{1}{4}$ = $\\frac{3}{12}$, $\\frac{1}{3}$ = $\\frac{4}{12}$. Samen: $\\frac{7}{12}$.",
          "1": "$\\frac{2}{7}$ is fout. Je hebt de tellers opgeteld (1+1=2) én de noemers opgeteld (4+3=7). De noemers mag je niet optellen. Zoek het KGV: 12. Dan $\\frac{3}{12}$ + $\\frac{4}{12}$ = $\\frac{7}{12}$.",
          "2": "$\\frac{2}{12}$ is fout. Je hebt de tellers opgeteld (1+1=2) maar de noemer correct als 12 genomen. Vergeet niet de tellers ook om te zetten: $\\frac{1}{4}$ = $\\frac{3}{12}$ (niet $\\frac{1}{12}$) en $\\frac{1}{3}$ = $\\frac{4}{12}$ (niet $\\frac{1}{12}$).",
          "3": "$\\frac{1}{12}$ is fout. Je hebt misschien de tellers vermenigvuldigd (1×1=1) en de noemers vermenigvuldigd (4×3=12). Dat is de regel voor vermenigvuldigen, niet voor optellen. Bij optellen maak je de noemers gelijk via het KGV."
        }
      }
    },
    {
      "id": "GET-BREUK-ONG-PLUS-004",
      "familyId": "GET-BREUK-ONG-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_optellen_ong",
      "questionType": "multiple_choice",
      "question": "Jan drinkt $\\frac{1}{3}$ liter water. Later drinkt hij nog $\\frac{1}{2}$ liter. Hoeveel heeft hij in totaal gedronken?",
      "context": null,
      "options": ["$\\frac{5}{6}$", "$\\frac{2}{5}$", "$\\frac{1}{6}$", "$\\frac{2}{6}$"],
      "correctAnswer": 0,
      "conceptId": "adding_fractions_context_water",
      "variantIndex": 4,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 1, "denominator": 3, "label": "1/3 liter"},
              {"numerator": 1, "denominator": 2, "label": "1/2 liter"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 6,
            "label": "1/3 = 2/6, 1/2 = 3/6, dan 2/6 + 3/6 = 5/6 liter",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{5}{6}$ liter. De noemers zijn ongelijk (3 en 2). Het KGV van 3 en 2 is 6. Maak gelijknamig: $\\frac{1}{3}$ = $\\frac{2}{6}$ en $\\frac{1}{2}$ = $\\frac{3}{6}$. Dan: $\\frac{2}{6}$ + $\\frac{3}{6}$ = $\\frac{5}{6}$ liter.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{3}$ = $\\frac{2}{6}$ en $\\frac{1}{2}$ = $\\frac{3}{6}$. Samen: $\\frac{2}{6}$ + $\\frac{3}{6}$ = $\\frac{5}{6}$ liter.",
          "1": "$\\frac{2}{5}$ is fout. Je hebt de tellers opgeteld (1+1=2) én de noemers opgeteld (3+2=5). De noemers mag je niet optellen. Zoek het KGV: 6. Dan $\\frac{2}{6}$ + $\\frac{3}{6}$ = $\\frac{5}{6}$.",
          "2": "$\\frac{1}{6}$ is fout. Je hebt misschien de tellers vermenigvuldigd (1×1=1) en de noemers vermenigvuldigd (3×2=6). Dat is de regel voor vermenigvuldigen, niet voor optellen.",
          "3": "$\\frac{2}{6}$ is fout. Je hebt alleen $\\frac{1}{3}$ omgezet naar $\\frac{2}{6}$ maar de tweede breuk vergeten op te tellen. $\\frac{2}{6}$ + $\\frac{3}{6}$ = $\\frac{5}{6}$."
        }
      }
    }
  ]
}